/**
 * Console-safe copy of a value: credentials, identity fields and anything
 * token-shaped inside a string are masked. Authored lesson text is kept.
 */

const SECRET_KEY_RE = /token|secret|password|passwd|pwd|authorization|api[-_]?key|apisecret|cookie|email|credential/i;
const ID_KEY_RE = /^(student|studentCourse|studentCourseStep|course|user|person|account|company)[-_]?id$/i;
const JWT_RE = /eyJ[A-Za-z0-9_-]{4,}\.[A-Za-z0-9_-]{4,}\.[A-Za-z0-9_-]{4,}/g;
const BEARER_RE = /Bearer\s+[A-Za-z0-9._~+/-]+=*/gi;
const EMAIL_RE = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi;

export function redactString(text: string): string {
  return text
    .replace(JWT_RE, '[token]')
    .replace(BEARER_RE, 'Bearer [token]')
    .replace(EMAIL_RE, '[email]');
}

export function redactForLog(value: unknown, depth = 0): unknown {
  if (typeof value === 'string') return redactString(value);
  if (value === null || typeof value !== 'object') return value;
  if (depth > 6) return '[nested]';
  if (Array.isArray(value)) return value.map((item) => redactForLog(item, depth + 1));
  const out: Record<string, unknown> = {};
  for (const [key, item] of Object.entries(value as Record<string, unknown>)) {
    if (SECRET_KEY_RE.test(key)) {
      out[key] = item ? '[redacted]' : item;
    } else if (ID_KEY_RE.test(key)) {
      out[key] = item ? '[id]' : item;
    } else {
      out[key] = redactForLog(item, depth + 1);
    }
  }
  return out;
}
